import isPresent from './is_present';

export default function formatNumber(number) {
  if (isPresent(number)) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}